<template>
  <v-container>
    <installer-creation-dialog
      v-model="installerDialog"
      v-on:create-installer="createInstaller($event)"
    />
    <v-row>
      <v-col>
        <v-row justify="space-between">
          <v-col lg="4" sm="8">
            <h1 class="display-1 font-weight-light">
              {{ $t("Manage_Installers.Installers") }}
            </h1>
          </v-col>
          <v-col lg="2" align="right">
            <v-btn outlined color="green" v-on:click="installerDialog = true">
              <v-icon left>mdi-plus</v-icon>
              {{ $t("Generic.Add") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              :label="$t('Generic.Search')"
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :loading="isLoading"
              :headers="headers"
              :items="installers"
              :search="search"
              :items-per-page="rowsPerPage"
              :no-data-text="$t('Generic.No_Data')"
              :no-results-text="$t('Generic.No_Data_Search')"
              class="elevation-1"
              :footer-props="{
                itemsPerPageText: $t('Generic.Rows_per_page')
              }"
            >
              <template v-slot:item.Actions="{ item }">
                <v-btn small text icon color="blue" class="ma-0 pa-0">
                  <v-icon
                    small
                    class="ma-0 pa-0"
                    v-on:click="goToInstallerPage(item)"
                  >
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import InstallerService from "../services/InstallerService";
import InstallerCreationDialog from "@/components/Installers/InstallerCreationDialog.vue";

export default {
  components: {
    InstallerCreationDialog
  },
  data() {
    return {
      installerDialog: false,
      search: "",
      isLoading: true,
      rowsPerPage: 10,
      installers: [],
      headers: [
        {
          text: this.$i18n.t("Generic.Name"),
          align: "left",
          value: "name"
        },
        {
          text: this.$i18n.t("Generic.Actions"),
          value: "Actions",
          align: "right",
          sortable: false
        }
      ]
    };
  },
  methods: {
    goToInstallerPage(installer) {
      this.$router.push({
        name: "InstallerDetails",
        params: { id: installer.id }
      });
    },
    createInstaller(installer) {
      InstallerService.CreateInstaller(installer)
        .then(response => {
          this.installerDialog = false;
          this.installers.push(response.data);
          this.$emit("show-success", this.$i18n.t("Success.Installer_Created"));
        })
        .catch(error =>
          this.$emit(
            "show-error",
            this.$i18n.t("Error.Installer_Creation_Failed")
          )
        );
    }
  },
  mounted() {
    InstallerService.GetAllInstallers()
      .then(response => (this.installers = response.data))
      .catch(error =>
        this.$emit("show-error", this.$i18n.t("Error.Installers_Not_Retrieved"))
      )
      .finally(() => (this.isLoading = false));
  }
};
</script>
